import React from 'react';

export const CitiesIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.667 15.6l.62-3.721a.334.334 0 01.329-.279h8.768c.163 0 .303.118.33.279l.62 3.721M10 11.6l-.637-6.366a.333.333 0 00-.333-.3H2.969a.333.333 0 00-.334.3L2 11.6M8.667 4.93v-2H3.333v2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.667 2.933L6.236.5a.333.333 0 00-.471 0h-.001l-2.43 2.433M4.333 7.929v-1M6 7.929v-1M7.667 7.929v-1M4.333 10.262v-1M6 10.262v-1M7.667 10.262v-1M4.333 14.262v-1M2.667 14.262v-1M9.333 14.262v-1M6 14.262v-1M7.667 14.262v-1"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
